import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getUserSnapshotsList } from '../actions/api'
import { setShowUserHistory, setUserSnapshotList, setUserModifyingDateTimeArray, setUserSelectedSnapshotIndex, setCurrentUserState } from '../actions/localStates'

import { formatDateForCalendar } from '../actions/helpers'

import UserHistoryView from '../components/UserHistoryView'

class UserHistoryContainer extends Component {

	constructor(props) {
        super(props);

        this.state = {
        }
    }

	componentDidMount() {
        var dateArray = [], _this = this, urlString = "?page=0&size=20&sort=modifyingDateTime,desc";
		this.props.actions.setShowUserHistory(true)
        var data = {
          "userName": this.props.user.userName, //"postman-user-173001"
          "modifyingDateTimeNotBefore": null,
          "modifyingDateTimeNotAfter": null,
          "modifyingInitiatorId": null,
          "operator": null
        }

        this.props.actions.getUserSnapshotsList(this.props.base.serviceUrl, this.props.login.accessToken, data, urlString)
        .then((response) => {
            console.log(response)

            if (response.contentType !== undefined && response.contentType !== "application/ccs.api.error+json;charset=UTF-8") {
                this.props.actions.setErrorResponse(response.json)
                this.setState({showErrorPopup: true})
                return
            }

            if (response.content.length > 0) {
                if (response.content.length < response.page.totalElements) {
                    urlString = "?page=0&size=" + response.page.totalElements + "&sort=modifyingDateTime,desc"
                } else {
                    urlString = "?page=0&size=20&sort=modifyingDateTime,desc"
                }

                this.props.actions.getUserSnapshotsList(this.props.base.serviceUrl, this.props.login.accessToken, data, urlString)
                .then((response) => {
                    if (response.contentType !== undefined && response.contentType !== "application/ccs.api.error+json;charset=UTF-8") {
                        this.props.actions.setErrorResponse(response.json)
                        this.setState({showErrorPopup: true})
                        return
                    }

                    this.props.actions.setCurrentUserState(null)
                    this.props.actions.setUserSnapshotList(response.content)
                    response.content.forEach((element) => {
                        dateArray.push(_this.props.actions.formatDateForCalendar(element.modifyingDateTime))
                    })

                    var enquire = JSON.parse(response.content[0].userJson)
                    // this.props.actions.clearTokenEnquire()
                    window.setTimeout(function () {
                        _this.props.actions.setCurrentUserState(enquire)
                    }, 25)
                    this.props.actions.setUserSelectedSnapshotIndex(0)

                    this.props.actions.setUserModifyingDateTimeArray(dateArray)
                })
            } else {
                this.props.actions.setCurrentUserState(null)
                this.props.actions.setUserSnapshotList([])
                this.props.actions.setUserSelectedSnapshotIndex(0)
                this.props.actions.setUserModifyingDateTimeArray([])
            }
        })
	}

	render() {
		return (
			<UserHistoryView />
		);
	}
}

function mapStateToProps(state) {
    return {
        base: state.base,
        user: state.userReducer,
        login: state.loginReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
        setShowUserHistory, getUserSnapshotsList,
        setUserSnapshotList, setUserModifyingDateTimeArray, setUserSelectedSnapshotIndex,
        setCurrentUserState, formatDateForCalendar
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(UserHistoryContainer);